type MarqueeDirection = 'normal' | 'reverse';

export function initMarquee() {
    const marquees = document.querySelectorAll('.marquee') as NodeListOf<HTMLElement>;

    marquees.forEach((marquee) => {
        if (marquee.dataset.marqueeInited === 'true') return;

        const direction: MarqueeDirection = marquee.classList.contains('marquee-reverse')
            ? 'reverse'
            : 'normal';

        const children = Array.from(marquee.children);

        if (direction === 'normal') {
            // Клонируем элементы в конец
            children.forEach((child) => marquee.appendChild(child.cloneNode(true)));
        } else {
            // Клонируем элементы в начало
            children.reverse().forEach((child) => marquee.insertBefore(child.cloneNode(true), marquee.firstChild));
        }

        marquee.dataset.marqueeInited = 'true';
    });
}
